import { Link } from "react-router-dom";
import { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Twitter, Facebook, Instagram } from "lucide-react";
import { Logo } from "@/components/Logo";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.includes("@")) return toast.error("Please enter a valid email");
    setLoading(true);
    try {
      await api.post("/newsletter", { email });
      toast.success("You're in. Deals inbound.");
      setEmail("");
    } catch {
      toast.error("Subscription failed. Try again.");
    }
    setLoading(false);
  };

  return (
    <footer className="border-t border-slate-200 bg-slate-950 text-slate-100 mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2 mb-4">
              <Logo size={32} />
              <span className="font-display text-xl tracking-tighter">SharePromos</span>
            </div>
            <p className="text-sm text-slate-400 max-w-sm leading-relaxed mb-6">
              Verified coupons and cashback deals from 500+ trusted retailers. Updated daily by real editors — never scraped, never spammed.
            </p>
            <form onSubmit={submit} className="flex gap-2 max-w-sm" data-testid="footer-newsletter-form">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@email.com"
                className="flex-1 px-4 py-3 bg-slate-900 border border-slate-800 rounded-sm text-sm focus:border-emerald-500 focus:outline-none"
                data-testid="newsletter-email-input"
              />
              <button
                type="submit"
                disabled={loading}
                className="px-5 py-3 bg-emerald-500 text-slate-950 font-bold text-sm hover:bg-emerald-400 transition-colors rounded-sm disabled:opacity-50"
                data-testid="newsletter-submit-btn"
              >
                {loading ? "..." : "Join"}
              </button>
            </form>
          </div>

          <div className="md:col-span-2">
            <p className="overline text-slate-500 mb-4">Discover</p>
            <ul className="space-y-3 text-sm">
              <li><Link to="/stores" className="hover:text-emerald-400">All Stores</Link></li>
              <li><Link to="/categories" className="hover:text-emerald-400">Categories</Link></li>
              <li><Link to="/blog" className="hover:text-emerald-400">Money Blog</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="overline text-slate-500 mb-4">Company</p>
            <ul className="space-y-3 text-sm">
              <li><a href="#" className="hover:text-emerald-400">About</a></li>
              <li><a href="#" className="hover:text-emerald-400">How it works</a></li>
              <li><a href="#" className="hover:text-emerald-400">Contact</a></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="overline text-slate-500 mb-4">Follow</p>
            <div className="flex gap-3">
              <a href="#" className="w-10 h-10 border border-slate-800 hover:border-emerald-500 flex items-center justify-center rounded-sm transition-colors">
                <Twitter className="w-4 h-4" />
              </a>
              <a href="#" className="w-10 h-10 border border-slate-800 hover:border-emerald-500 flex items-center justify-center rounded-sm transition-colors">
                <Facebook className="w-4 h-4" />
              </a>
              <a href="#" className="w-10 h-10 border border-slate-800 hover:border-emerald-500 flex items-center justify-center rounded-sm transition-colors">
                <Instagram className="w-4 h-4" />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-slate-800 flex flex-col md:flex-row justify-between text-xs text-slate-500 gap-3">
          <p>&copy; {new Date().getFullYear()} SharePromos. All coupons verified by human editors.</p>
          <p>Made for smarter shoppers.</p>
        </div>
      </div>
    </footer>
  );
}
